import { ReactElement } from "react";

export default function Home(): ReactElement {
  return <></>;
}
